import {useReservationSettings} from 'hooks/useReservationSettings';
import {useReservation} from 'context/reservation';

function useCanEditGuestCount() {
  const {allowEditingGuestNumber} = useReservation();
  const {checkCanEditReservationDetails} = useReservationSettings();

  return Boolean(checkCanEditReservationDetails() && allowEditingGuestNumber);
}

export {useCanEditGuestCount};
